module.exports = __webpack_public_path__ + "static/media/header-mail-dark.ba16d2ca.svg";